import React from "react";
import { useParams } from "react-router-dom";
import { ShipdayLogo, ShipdayText } from "../Login/logos";
import InvitationSignUpForm from "./invitationSignUpForm";
import styles from "../Login/login.module.css";
import LoadingSpinner from "../CommonComponents/loadingSpinner";
import { useFetchUserInvitationByIdentifierQuery } from "../../Apis/userInvitationsApi";

const InvitationSignUpPageWrapper = () => {
  const { identifier } = useParams();
  const {
    data: invitationSignup,
    isLoading,
    isFetching,
    isError,
  } = useFetchUserInvitationByIdentifierQuery(identifier);
  const loading = isLoading || isFetching;

  if (loading) {
    return (
      <div className={styles.fullPage}>
        <LoadingSpinner />
      </div>
    );
  }

  if (isError || !invitationSignup) {
    return (
      <div className={styles.fullPage}>
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
            <div style={{fontSize: '32px', fontFamily: 'Inter'}}>Signup link expired. Please contact your administrator.</div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.fullPage}>
      <div className={styles.header}>
        <div className={styles.logoContainer}>
          <ShipdayLogo />
          <ShipdayText />
        </div>
      </div>
      <InvitationSignUpForm invitation={invitationSignup} />
    </div>
  );
};

export default InvitationSignUpPageWrapper;
